import styled from 'styled-components';

export const SelectionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LeftText = styled.h1`
  font-size: 12px;
  line-height: 140%;
  font-weight: 600;
  color: #4D4D4D;
  margin-left: 10px;
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconWrapper = styled.div`
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
`;

export const RightText = styled.p`
  font-size: 10px;
  line-height: 140%;
  color: #4D4D4D;
  margin-right: 10px;
  padding: 8px;
  background-color: #F5F5F5;
  border-radius: 4px;
  cursor: pointer;
`;